import { ABOUT } from "@/data/content";
import Reveal from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-paper">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">01 · About the Conference</p>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]">
                A global stage for the <span className="text-crimson">next biotech breakthrough.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-10 relative overflow-hidden">
                <img
                  src="/about/kalasalingam.avif"
                  alt="Kalasalingam Academy of Research and Education campus"
                  loading="lazy"
                  className="w-full h-72 object-cover grayscale hover:grayscale-0 transition-all duration-700"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <Reveal delay={0.05}>
              <p className="text-lg sm:text-xl leading-relaxed text-ink/75">{ABOUT.body}</p>
            </Reveal>
            <div className="grid grid-cols-2 sm:grid-cols-4 mt-12 border-t border-l border-ink/10">
              {ABOUT.stats.map((s, i) => (
                <Reveal key={s.label} delay={0.08 * i}>
                  <div className="border-r border-b border-ink/10 p-6">
                    <div className="font-heading text-2xl sm:text-3xl font-bold text-crimson tracking-tight">{s.value}</div>
                    <div className="font-mono text-[11px] uppercase tracking-wider text-ink/55 mt-2">{s.label}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
